import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { DeviceService } from 'src/app/Service/Device/Device.service';

@Component({
  selector: 'app-DeviceMapping',
  templateUrl: './DeviceMapping.component.html',
  styleUrls: ['./DeviceMapping.component.scss']
})
export class DeviceMappingComponent implements OnInit {

  @Input() inner_calibration_detail_id:number=0
  @Input() selected_mapping_item:string=''


  @Output() outter_selected_mapping = new EventEmitter<string>();
  constructor(
    private Device_Service:DeviceService,
  ) { }

  ngOnInit() {this.ReadData_Mapping()
  }

  DataList_Mapping:Array<General_Interface>=[]

  ReadData_Mapping(){

    this.Device_Service.GetDeviceFile(this.inner_calibration_detail_id).subscribe(
      data=>{
        this.DataList_Mapping=data
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }


  Set_Selected_DeviceBehfa_Record() {
    this.outter_selected_mapping.emit(this.selected_mapping_item+'');
  }


}
